<div *ngIf="listItems && listItems.length > 0">
  <h4>{{listTitle}}</h4>
  <app-inline-list [listItems]="listItems"></app-inline-list>
</div>
